import { render } from "./content.vue?vue&type=template&id=56f515ec&scoped=true&ts=true"
import script from "./content.vue?vue&type=script&lang=ts"
export * from "./content.vue?vue&type=script&lang=ts"

import "./content.vue?vue&type=style&index=0&id=56f515ec&lang=less&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56f515ec"]])

export default __exports__